import React from 'react'
import { Route } from 'react-router-dom'
import MultiFactorAuth from './MultiFactorAuth'

import { multiFactorAuthRoot } from "../../../constants/routePaths"

const MultiFactorAuthRoute = [
  <Route
    key="MultiFactorAuth"
    exact path={multiFactorAuthRoot}
    component={MultiFactorAuth}
  />,
];

export default MultiFactorAuthRoute